import './Range.scss'

import { useEffect, useRef, useState } from "react"

const Range = ({ control, min, max, label, defaultValue, onChange }) => {
    const rangeRef = useRef()

    const onRangeChange = (event) => {
        if (control) control.setValue(event.target.value)
        if (onChange) onChange(event.target.value)
    }

    const updateFromValue = (value) => {
        if (Number.isFinite(value) && value !== rangeRef.current.value) {
            rangeRef.current.value = value
            if (onChange) onChange(value)
        }
    }

    useEffect(() => {
        if (control) updateFromValue(control.value)
    }, [control?.value])

    useEffect(() => {
        if (control) updateFromValue(control.value)
        else rangeRef.current.value = defaultValue || min
    }, [])

    return (
        <div className="range">
            {label && <span className="label d-block mb-3">{label}</span>}
            <div className="flex-center-y">
                <input className="input" type="range" min={min} max={max} onChange={onRangeChange} ref={rangeRef} />
                <span className="ml-3">{control.value}</span>
            </div>
        </div>
    )
}

export default Range